<div ng-show="maps && maps.length">
  <div ng-if="mapType === 'date'">
    <h3>
      <ng-pluralize count="maps.length" when="{
        one: 'Mapa de dados visível',
        other: 'Mapas de dados visíveis'
      }"></ng-pluralize>
      &sdot;
      <a ng-click="clearHeatMap()">Limpar</a>
    </h3>
    <p>
      <i class="fa fa-map-marker"></i>
      {{maps[0].gleba.descricao | capitalize}}
      <i class="fa fa-calendar"></i>
      {{maps[0].data | date}}
      <i class="fa fa-map"></i>
      {{maps[0].descricao | capitalize}}
      <span ng-if="maps.length > 1">(e mais {{maps.length - 1}})</span>
    </p>
  </div>
  <div ng-if="mapType === 'machine'">
    <h3>
      <span>Uso de máquina visível</span>
      &sdot;
      <a ng-click="clearHeatMap()">Limpar</a>
    </h3>
    <p>
      <i class="icon-fulltrator"></i>
      {{maps[0].maquina.descricao | capitalize}}
      <i class="fa fa-cogs"></i>
      {{maps[0].operacao.descricao | capitalize}}
      <span ng-if="maps.length > 1">(e mais {{maps.length - 1}})</span>
      <p>
        <i class="fa fa-calendar"></i>
        {{maps[0].dt_inicial_ps | date}} - {{maps[0].dt_final_ps | date}}
      </p>
    </p>
  </div>
  <div ng-if="mapType === 'aplicacao'">
    <h3>
      <span>{{maps[0].title}}</span>
      &sdot;
      <a ng-click="clearHeatMap()">Limpar</a>
    </h3>
    <p>
      <i class="fa fa-map-marker"></i>
      {{maps[0].gleba.descricao | capitalize}}
      <i class="fa fa-calendar"></i>
      {{maps[0].dt_ini | date}} - {{maps[0].dt_fim | date}}
      <span ng-if="maps.length > 1">(e mais {{maps.length - 1}})</span>
    </p>
  </div>
</div>
